import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";

import "./batch-status/composition.scss";
import { Success } from "../svg/svgImageList";
import { Dialog } from "../../components/dialog/Dialog";
import { LeavePagesEnum, useLeavePagePrompt } from "../../helpers/useLeavePagePrompt";
import { batchHighlightDetectionService } from "../../services/batch-processing/BatchHighlightDetectionService";
import BatchHighlightDetectionProgressSnackbar from "./BatchHighlightDetectionProgressSnackbar";
import BatchHighlightDetectionStatus from "./batch-status/BatchHighlightDetectionStatus";
import { translationService } from "../../services/translation/TranslationService";

export default observer(function BatchHighlightDetectionStatusOverview() {
  const [setLeavePagePrompt] = useLeavePagePrompt();

  useEffect(() => {
    setLeavePagePrompt(
      batchHighlightDetectionService.statusModel.isProcessing,
      LeavePagesEnum.BatchHighlightDetection
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [batchHighlightDetectionService.statusModel.isProcessing]);

  return (
    <>
      <BatchHighlightDetectionProgressSnackbar />
      <Dialog
        titleKey={"damages.BatchProcessingStatus.title.HighlightDetection"}
        titleContext={{ itemsCount: batchHighlightDetectionService.statusModel.videoCount }}
        sidePosition
        isVisible={batchHighlightDetectionService.statusModel.displayStatusModal}
        onHide={batchHighlightDetectionService.statusModel.hideStatusBatchModal}
        buttonOk={{
          id: "status-video-analysis",
          textKey: "general.ok",
          action: batchHighlightDetectionService.statusModel.hideStatusBatchModal,
        }}
      >
        <BatchHighlightDetectionStatus />
      </Dialog>
      <Dialog
        titleKey="damages.BatchProcessingStatus.finalized.title"
        isVisible={batchHighlightDetectionService.statusModel.displayFinalizedModal}
        onHide={batchHighlightDetectionService.statusModel.hideStatusBatchModal}
        iconTitle={{
          svg: Success,
          width: 30,
          height: 30,
          className: "icon-success",
        }}
        buttonOk={{
          textKey: "general.upload.view-details",
          action: batchHighlightDetectionService.statusModel.showStatusBatchModal,
        }}
        buttonCancel={{
          textKey: "general.cancel",
          action: batchHighlightDetectionService.statusModel.hideStatusBatchModal,
        }}
      >
        <div className={"subtext-dialog"}>
          <div>
            {translationService.translate("damages.BatchProcessingStatus.finalized.message", {
              itemsCount: batchHighlightDetectionService.statusModel.videoCount,
            })}
          </div>
        </div>
      </Dialog>
    </>
  );
});
